import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatRadioModule} from '@angular/material/radio';
import {FormsModule} from '@angular/forms';
import {SeriesScope} from '@xmedical/core';

export interface AppointmentScopeDialogData {
  /** What the user asked to do — drives the wording and the confirm button. */
  action: 'edit' | 'cancel';
  /** The recurrence summary, shown so the user knows which series they're about to affect. */
  summary?: string;
}

/**
 * Asks how far a change to a recurring occurrence should reach.
 *
 * Closes with a SeriesScope, or undefined if dismissed. There are deliberately only two
 * options — the backend has no "all occurrences" scope, because "all" is exactly
 * ThisAndFollowing on the earliest occurrence, and rewriting past occurrences would erase
 * the record that the time was ever blocked out.
 */
@Component({
  selector: 'app-appointment-scope-dialog',
  templateUrl: './appointment-scope-dialog.component.html',
  styleUrls: ['./appointment-scope-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, MatRadioModule, FormsModule],
})
export class AppointmentScopeDialogComponent {
  scope: SeriesScope = 'This';

  private dialogRef = inject<MatDialogRef<AppointmentScopeDialogComponent, SeriesScope | undefined>>(MatDialogRef);
  readonly data = inject<AppointmentScopeDialogData>(MAT_DIALOG_DATA);

  get isCancel(): boolean {
    return this.data.action === 'cancel';
  }

  confirm(): void {
    this.dialogRef.close(this.scope);
  }

  dismiss(): void {
    this.dialogRef.close(undefined);
  }
}
